import { makeStyles, tokens } from '@fluentui/react-components';

export const useStyles = makeStyles({
  issueList: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalXS,
  },

  issue: {
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    borderRadius: tokens.borderRadiusMedium,
    borderLeftWidth: tokens.strokeWidthThick,
    borderLeftStyle: 'solid',
  },

  error: {
    color: tokens.colorPaletteRedForeground1,
    backgroundColor: tokens.colorPaletteRedBackground1,
    borderLeftColor: tokens.colorPaletteRedBorder1,
  },

  section: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },

  bindingRows: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalS,
  },

  bindingHeader: {
    display: 'grid',
    gridTemplateColumns: '1fr 140px 1fr 32px',
    gap: tokens.spacingHorizontalS,
    fontSize: tokens.fontSizeBase200,
    color: tokens.colorNeutralForeground3,
    fontWeight: tokens.fontWeightSemibold,
    paddingTop: tokens.spacingVerticalXS,
  },

  bindingRow: {
    display: 'grid',
    gridTemplateColumns: '1fr 140px 1fr 32px',
    alignItems: 'start',
    gap: tokens.spacingHorizontalS,
    '& > *': {
      minWidth: 0,
    },
  },

  empty: {
    color: tokens.colorNeutralForeground3,
  },
});
